export default "__VITE_ASSET__D8X_D2NS__"